import React from 'react';
import { useLogin } from '../hooks/useLogin';

type EmailVerificationProps = { children: React.ReactNode };

const EmailVerification = ({ children }: EmailVerificationProps) => {
	const { emailAndPasswordTitle } = useLogin();

	return (
		<div>
			<div className="vtex-login-2-x-emailVerification emailVerification vtex-login-2-x-emailAndPasswordForm emailAndPasswordForm w-100">
				<h3 className="vtex-login-2-x-formTitle formTitle t-body v-mid ttu tc relative pv2 ph3 br2">
					{emailAndPasswordTitle}
				</h3>
				<form>{children}</form>
			</div>
		</div>
	);
};

export default EmailVerification;
